export default theme => ({
  card: {
    paddingTop: 20,
  },
});
